import React, { useRef } from "react";
import CardSlider from "./CardSlider";
import { SwiperSlide } from "swiper/react";
import NavigationButton from "./SliderBtn";
import Cards from "../Cards";

const TestimonialsSlider = ({ data }) => {
  const swiperRef = useRef(null);

  return (
    <div>
      
      {" "}
      <CardSlider onSwiper={(swiper) => (swiperRef.current = swiper)}>
        {data.map((card, index) => {
          return (
            <SwiperSlide key={index} style={{ width: "fit-content" }}>
              <Cards name={card.name} rating={card.rating} para={card.para} img={card.image} />
            </SwiperSlide>
          );
        })}
           
      </CardSlider>
      {data.length >= 4 && (
        <div>
          <NavigationButton swiperRef={swiperRef} type="prev" />
          <NavigationButton swiperRef={swiperRef} type="right" />
        </div>
      )}
    </div>
  );
};

export default TestimonialsSlider;
